import React, { useState, cloneElement, useEffect } from 'react';
import { MenuItem } from 'react-pro-sidebar';
import { useLocation, useNavigate } from 'react-router-dom';

import { MenuItemLinkProps } from './types';

const MenuItemLink: React.FC<MenuItemLinkProps> = ({
  to,
  icon,
  label,
  onClick,
  external,
  subLinks,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState<boolean>(false);

  useEffect(() => {
    const fullPath = `${location.pathname}${location.search}`;
    setIsActive(!!(location.pathname === to || subLinks?.includes(fullPath)));
  }, [location.pathname, location.search, to, subLinks]);

  const [isHover, setIsHover] = useState<boolean>(false);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (onClick) {
      onClick(event);
    } else if (to && !external) {
      navigate(to);
    }
  };

  const hoveredColor = isActive || isHover ? '#ffffff' : '#CBD2D9';

  const iconElement = icon ? (
    <div
      style={{
        width: '48px',
        height: '48px',
        padding: '8px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        backgroundColor: isActive ? '#8BBC07' : 'transparent',
      }}
    >
      {cloneElement(icon, { strokeColor: hoveredColor })}
    </div>
  ) : null;

  return (
    <MenuItem
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      active={isActive}
      onClick={handleClick}
      className={isActive ? 'active' : ''}
      href={external ? to : undefined}
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}
      style={{ color: hoveredColor }}
    >
      {iconElement}
      <span style={{ color: hoveredColor, whiteSpace: 'pre-line' }}>
        {label}
      </span>
    </MenuItem>
  );
};

export default MenuItemLink;
